// TSS vite/04 §"Endpoint paths".
// PROVISIONAL(0106 / Tier 95) — evento de market multi-vaca, canal PÚBLICO SIN
// auth de sesión (capability-token). El contrato formal (Q-320) todavía NO está
// escrito: rutas/shapes van contra el DISEÑO de 0106/Q-318, con lectura
// tolerante. `token` = `public_token` del evento (en el path).
export const eventPaths = {
    // GET — publicLiveState del evento (sin PII), envuelto en el sobre público.
    dashboard: (token) => `public/market-events/${token}/dashboard`,
    // POST { name, cedula, email } → devuelve participant_token (idempotente por cédula).
    register:  (token) => `public/market-events/${token}/register`,
    // POST { percent } con participant_token → toma % de esa vaca (FCFS, Σ≤offered).
    bid:       (token, offeringId) => `public/market-events/${token}/offerings/${offeringId}/bids`,
};
